var map = {
	"./default/img/menu/cart.png": "cec8",
	"./default/img/menu/chance.png": "564b",
	"./default/img/menu/history.png": "6df2",
	"./default/img/menu/home.png": "9089",
	"./default/img/menu/loto-4-59-luckia.png": "072a",
	"./default/img/menu/loto-4-59.png": "710a",
	"./default/img/menu/loto-chance.png": "be70",
	"./default/img/menu/loto-nap.png": "7014",
	"./default/img/menu/loto-turbo.png": "bcce",
	"./default/img/menu/loto649.png": "05df",
	"./default/img/menu/lotto-5-45.png": "013c",
	"./default/img/menu/lotto-6-45.png": "baf3",
	"./default/img/menu/nap.png": "7231",
	"./default/img/menu/results.png": "8a87",
	"./default/img/menu/turbo.png": "42bf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b67e";